import type { BorescopeInspectionRecord } from '@avisoma/shared';
import { BorescopeFindingsTable } from '../../components/reconstructedDocument/extractionTables/BorescopeFindingsTable';
import {
  borescopeFindings,
  presentBorescopeFields,
} from '../../components/reconstructedDocument/extractionTables/borescopePresentation';

/**
 * The page's Borescope Report record (DR-4817): its scalars as a label grid, then one row per
 * inspected area. Same card shell as the page's Engine Workscope card. Renders nothing when the
 * record carries neither.
 */
export function BorescopeInspectionCard({ record }: { record: BorescopeInspectionRecord }) {
  const entries = presentBorescopeFields(record);
  const findings = borescopeFindings(record);
  if (entries.length === 0 && findings.length === 0) return null;
  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden border border-gray-200 dark:border-zinc-700">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-zinc-700">
        <h2 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Borescope Report</h2>
      </div>
      {entries.length > 0 && (
        <div className="px-4 py-4">
          <dl className="grid grid-cols-3 gap-4">
            {entries.map(([label, value]) => (
              <div key={label}>
                <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">{label}</dt>
                <dd className="mt-1 text-sm text-gray-900 dark:text-zinc-100">{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
      {findings.length > 0 && (
        <div className="border-t border-gray-200 dark:border-zinc-700 overflow-x-auto">
          <BorescopeFindingsTable rows={findings} />
        </div>
      )}
    </div>
  );
}
